import * as React from 'react'
import { ReactElement } from 'react'
import BaseDropdown, { DropdownProps } from './BaseDropdown'

export enum Direction {
    Ascending = 'ASCENDING',
    Descending = 'DESCENDING',
}

export default function SortDropdown(props: Omit<DropdownProps, 'canClear' | 'options'>): ReactElement {
    return (
        <BaseDropdown
            {...props}
            required={false}
            label="Sortering"
            canClear={false}
            options={[
                { key: Direction.Ascending, text: 'Oud naar nieuw' },
                { key: Direction.Descending, text: 'Nieuw naar oud' },
            ]}
        />
    )
}
